<template>
  <ResumableUploadWrapper
    v-slot="{ uploading, percentage, errors, message, fileIndex, retry }"
    class="simple-resumable-uploader"
    :files="files"
    :upload-url="uploadUrl"
    @upload-done="emitUploadResponses"
  >
    <FileSelectorWrapper
      v-slot="{ openFileSelector }"
      v-bind="$attrs"
      :accept="accept"
      :disabled="uploading || disabled"
      @select-files="setFiles"
    >
      <slot
        :open-file-selector="openFileSelector"
        :uploading="uploading"
        :percentage="percentage"
        :errors="errors"
        :message="message"
        :file-index="fileIndex"
        :retry="retry"
      />
    </FileSelectorWrapper>
  </ResumableUploadWrapper>
</template>

<script>
import FileSelectorWrapper from '@@/common/file-selectors/FileSelectorWrapper';
import ResumableUploadWrapper from '@@/common/file-uploaders/ResumableUploadWrapper';

export default {
  name: 'ResumableUploader',

  components: {
    FileSelectorWrapper,
    ResumableUploadWrapper,
  },

  props: {
    accept: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: [String, Function],
      required: true,
    },
  },

  data() {
    return {
      files: [],
    };
  },

  methods: {
    setFiles(files) {
      this.files = files;
    },

    emitUploadResponses(responses) {
      this.$emit('upload-done', responses, this.files);
    },

    resetAndCancel() {
      this.files = null;
    },
  },
};
</script>
